import { c as _c } from "react/compiler-runtime";
import useUser from 'shared/hooks/use-user';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
import { TEMPLATES_API } from 'modules/courses/courses/curriculum/api/templates-api';
import { LectureTemplateInterface } from 'modules/courses/courses/curriculum/types/lecture-interface';
export function useLectureTemplate() {
  const $ = _c(2);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== user) {
    t0 = () => {
      if (user) {
        return `${TEMPLATES_API}`;
      }
    };
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useSWR(t0, baseFetcher);
}